/* istanbul ignore file */

export enum AudioLayout {
  NORMAL = 'normal',
  SIMPLE = 'simple',
  EXTENDED = 'extended',
}
